import { apiClient } from "@vv/api";
import type { AuditLogEntry, ListAuditLogFilter } from "../domain/audit-log.types";

export const auditLogApi = {
  list: (filter: ListAuditLogFilter = {}) => {
    const params = new URLSearchParams();
    if (filter.entityType) params.set("entityType", filter.entityType);
    if (filter.action) params.set("action", filter.action);
    if (filter.actorUserId) params.set("actorUserId", filter.actorUserId);
    const query = params.toString();
    return apiClient.get<AuditLogEntry[]>(`/audit-log${query ? `?${query}` : ""}`);
  },
};
